import React from "react";

import * as Typography from "~/Typography";

export type NotApplicable = { readonly NotApplicable?: React.Fn };

export function NotApplicable({
  children,
}: {
  readonly children?: React.ReactNode;
}) {
  return (
    <Typography.Component muted data-testid="not-applicable">
      {children ?? NotApplicable.text()}
    </Typography.Component>
  );
}

export namespace NotApplicable {
  export const text = () => "N/A" as const;
}
